
import { Card, Empty, Typography } from 'antd';
import { useIntl } from 'react-intl';

const { Title, Text } = Typography;

const NoRoomsAvailable:React.FC = () => {
  const intl = useIntl();

  return (
    <Card bordered={false} style={{ textAlign: 'center' }}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <>
            <Title level={4}>{intl.formatMessage({ id: 'booking.noRoomsAvailable.title', defaultMessage: 'No Rooms Available' })}</Title>
            <Text type="secondary">{intl.formatMessage({ id: 'booking.noRoomsAvailable.description', defaultMessage: 'Sorry, there are no rooms available for the selected dates. Please try different dates.' })}</Text>
          </>
        }
      >
      </Empty>
    </Card>
  );
}

export default NoRoomsAvailable